import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Icons } from '../../util/Icons';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { DateUtil } from '../../util/DateUtil';
import { DeviceInspection } from '@eadsysteme/devicemonitoringclient-v1';
import { CiState } from '../../services/CiState';
import { STATUS } from 'src/app/services/data/STATUS';
import InspectionStateEnum = DeviceInspection.InspectionStateEnum;
import OperationalStateEnum = DeviceInspection.OperationalStateEnum;

dayjs.extend(localizedFormat);

@Injectable({
	providedIn: 'root',
})
export class IconHelper {
	icons = inject(Icons);
	private translocoService = inject(TranslocoService);
	private dateUtil = inject(DateUtil);

	iconByCiState(state: CiState.CiState) {
		switch (state) {
			case CiState.CiState.NoOrder:
				return this.icons.get('cancelCircleOutline');
			case CiState.CiState.NoOrderButSettings:
				return this.icons.get('minusCircleOutline');
			case CiState.CiState.Order:
				return this.icons.get('checkCircleOutline');
		}
		return null;
	}

	getColorByInSync(inSync: boolean) {
		return inSync ? 'stateGreen' : 'stateYellow';
	}

	getIconByInSync(inSync: boolean) {
		return inSync ? this.icons.get('checkCircleOutline') : this.icons.get('minusCircleOutline');
	}

	getIconByInspectionState(inspectionState: InspectionStateEnum, operationalState: OperationalStateEnum) {
		switch (inspectionState) {
			case InspectionStateEnum.READY:
				return null;
			case InspectionStateEnum.IN_PROGRESS:
				return this.icons.get('hourglass_bot');
			case InspectionStateEnum.FINISHED:
				if (operationalState == OperationalStateEnum.NORMAL) {
					return this.icons.get('checkCircleOutline');
				} else if (operationalState == OperationalStateEnum.ERROR) {
					return this.icons.get('cancelCircleOutline');
				} else {
					return null;
				}
			default:
				return null;
		}
	}

	getColorByInspectionState(inspectionState: InspectionStateEnum, operationalState: OperationalStateEnum) {
		switch (inspectionState) {
			case InspectionStateEnum.READY:
				return null;
			case InspectionStateEnum.IN_PROGRESS:
				return 'stateYellow';
			case InspectionStateEnum.FINISHED:
				if (operationalState == OperationalStateEnum.NORMAL) {
					return 'stateGreen';
				} else if (operationalState == OperationalStateEnum.ERROR) {
					return 'stateRed';
				} else {
					return null;
				}
			default:
				return null;
		}
	}

	getColorByPeriodState(status: STATUS) {
		switch (status) {
			case STATUS.SUCCESS:
				return 'stateGreen';
			case STATUS.ERROR:
				return 'stateRed';
			default:
				return 'stateYellow';
		}
	}

	getIconByPeriodState(status: STATUS) {
		switch (status) {
			case STATUS.SUCCESS:
				return this.icons.get('checkCircleOutline');
			case STATUS.ERROR:
				return this.icons.get('cancelCircleOutline');
			default:
				return this.icons.get('minusCircleOutline');
		}
	}
}
